import { createRoot } from 'react-dom/client';
import { configure } from 'mobx';

import { HostApp } from './host-app';
import { initializeHostDatadog } from './datadog';

initializeHostDatadog();

configure({ enforceActions: 'observed' });

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

const root = createRoot(appContainer);
root.render(<HostApp />);
